// extracted by mini-css-extract-plugin
export default {"container":"theme_container__NQPS5","diffTable":"theme_diffTable__rxZw2","actions":"theme_actions__izmpc","classic":"theme_classic__OMtSZ"};